import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css'; // << esto es clave
import App from './App';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
